import React, { type JSX } from 'react'
import { Spinner } from '@mobi/component-library/Legacy/Spinner/Spinner'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { MainContainer } from '@core/Components/Containers'
import { ErrorMessage } from '@core/Components/Messages'

export const Loading = (): JSX.Element => (
  <MainContainer testId='bank-account-loading'>
    <PageHeader title='Bank Account' />
    <Spinner />
  </MainContainer>
)

export const Error = (): JSX.Element => (
  <MainContainer testId='bank-account-error'>
    <PageHeader title='Bank Account' />
    <ErrorMessage>Unable to load bank details at the moment. Please try again later.</ErrorMessage>
  </MainContainer>
)
